import { motion } from "framer-motion";
import { EASE, useSafeInView } from "@/components/Reveal";

const SIGNALS = [
  { x: 50, y: 50 }, { x: 50, y: 110 }, { x: 50, y: 170 }, { x: 50, y: 230 }, { x: 50, y: 290 },
];
const HUB = { x: 250, y: 170 };
const OUT = { x: 380, y: 170 };
const LABELS = ["deploy", "ticket", "org change", "spend", "adoption"];

export default function CorrelationDiagram() {
  const [ref, show] = useSafeInView();
  return (
    <div ref={ref}>
      <svg viewBox="0 0 420 340" className="h-auto w-full" data-testid="diagram-correlation-engine">
        {SIGNALS.map((s, i) => (
          <g key={i}>
            <motion.path
              d={`M 172 ${s.y} C 225 ${s.y}, ${HUB.x - 90} ${HUB.y}, ${HUB.x} ${HUB.y}`}
              fill="none"
              stroke="rgba(255,255,255,0.22)"
              strokeWidth="1"
              initial={{ pathLength: 0 }}
              animate={show ? { pathLength: 1 } : {}}
              transition={{ duration: 1.2, ease: EASE, delay: 0.2 + i * 0.12 }}
            />
            <motion.circle
              cx={s.x} cy={s.y} r="3.5"
              fill="#FFFFFF"
              initial={{ opacity: 0 }}
              animate={show ? { opacity: 0.9 } : {}}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            />
            <motion.text
              x={s.x} y={s.y - 13}
              fill="rgba(255,255,255,0.4)" fontSize="10" fontFamily="'JetBrains Mono', monospace"
              initial={{ opacity: 0 }}
              animate={show ? { opacity: 1 } : {}}
              transition={{ duration: 0.5, delay: 0.3 + i * 0.1 }}
            >
              {LABELS[i]}
            </motion.text>
          </g>
        ))}
        <motion.path
          d={`M ${HUB.x} ${HUB.y} L ${OUT.x} ${OUT.y}`}
          fill="none"
          stroke="#00C0C8"
          strokeWidth="1.2"
          initial={{ pathLength: 0 }}
          animate={show ? { pathLength: 1 } : {}}
          transition={{ duration: 0.8, ease: EASE, delay: 1.1 }}
        />
        <motion.g
          initial={{ opacity: 0, scale: 0 }}
          animate={show ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.7, ease: EASE, delay: 0.9 }}
          style={{ transformOrigin: `${HUB.x}px ${HUB.y}px` }}
        >
          <circle cx={HUB.x} cy={HUB.y} r="7" fill="#00C0C8" />
          <circle cx={HUB.x} cy={HUB.y} r="15" fill="none" stroke="#00C0C8" strokeOpacity="0.35" className="animate-pulse-soft" />
        </motion.g>
        <motion.g
          initial={{ opacity: 0 }}
          animate={show ? { opacity: 1 } : {}}
          transition={{ duration: 0.7, delay: 1.5 }}
        >
          <rect x={OUT.x - 6} y={OUT.y - 6} width="12" height="12" fill="none" stroke="#FFFFFF" strokeOpacity="0.8" />
          <text x={OUT.x - 20} y={OUT.y + 34} textAnchor="middle" fill="rgba(255,255,255,0.5)" fontSize="10" fontFamily="'JetBrains Mono', monospace">
            correlated pattern
          </text>
        </motion.g>
      </svg>
    </div>
  );
}
